import { shallowEqual, useSelector } from 'react-redux'

import { tr } from 'mmfintech-commons'

import { Button } from 'mmfintech-portal-commons'
import { TailSpin } from 'react-loader-spinner'
import { CheckoutButtonsWrapper } from './Checkout.styled'

interface ButtonsFooterProps {
  disabled: boolean
  onSubmit: () => void
  onCancel: () => void
  showCancel: boolean
  submitCaption?: string
}

export const ButtonsFooter = (props: ButtonsFooterProps) => {
  const { disabled, onSubmit, onCancel, showCancel, submitCaption } = props

  const { checkoutPayFetching } = useSelector(
    ({ checkout: { checkoutPayFetching } }) => ({
      checkoutPayFetching
    }),
    shallowEqual
  )

  return (
    <CheckoutButtonsWrapper>
      <Button
        type='button'
        color='primary'
        text={
          checkoutPayFetching ? (
            <TailSpin color='white' strokeWidth='4px' height='3rem' />
          ) : submitCaption ? (
            submitCaption
          ) : (
            tr('CHECKOUT.BUTTONS.CONTINUE', 'Continue')
          )
        }
        disabled={disabled}
        onClick={onSubmit}
        data-test='button-continue'
      />

      {showCancel ? (
        <Button
          type='button'
          color='secondary'
          text={tr('CHECKOUT.BUTTONS.CANCEL', 'Cancel')}
          disabled={checkoutPayFetching}
          onClick={onCancel}
          data-test='button-cancel'
        />
      ) : null}
    </CheckoutButtonsWrapper>
  )
}
